import { Dispatch, SetStateAction } from 'react'
import {
  DeliveryOptions,
  FormattedAddressAndProductAvailability,
  IsProductFulfillable,
} from '@interflora/ui-components/build/common/props'

declare global {
  interface Window {
    dataLayer: any
    ttdConversionEvents?: (...args: any[]) => void
  }
  // eslint-disable-next-line no-var
  var ttdConversionEvents: ((...args: any[]) => void) | undefined
}

const ifLogos = [
  '384x384',
  '48x48',
  '72x72',
  '96x96',
  '192x192',
  '16x16',
  '32x32',
  '512x512',
  '70x70',
  '144x144',
  '150x150',
  '310x310',
]

export const faviconObjects = ifLogos.map((value) => ({
  rel: 'icon',
  sizes: value,
  logoName: `favicon-${value}`,
}))
faviconObjects.push({
  rel: 'icon',
  sizes: '',
  logoName: 'favicon.ico',
})

const ifAppleLogos = ['60x60', '76x76', '120x120', '152x152', '180x180']

export const faviconAppleObjects = ifAppleLogos.map((value) => ({
  rel: 'apple-touch-icon',
  sizes: value,
  logoName: `favicon-${value}`,
}))

faviconAppleObjects.push(
  {
    rel: 'apple-touch-icon',
    sizes: '',
    logoName: 'apple-touch-icon',
  },
  {
    rel: 'apple-touch-icon',
    sizes: '',
    logoName: 'safari-pinned-tab.svg',
  }
)
export type AlgoliaQueryType = 'PDP' | 'PLP' | 'Search' | 'Autocomplete' | 'GuidedNav' | 'Favorites'
export type ProductOrderFrom = { productName: string; productOrderedFrom: string; lineItem: string }

// CustomPaginationProvider declares setLength as a React state setter but only ever calls it with a number
export type PaginationLengthSetter = Dispatch<SetStateAction<number>>

// The ui-components callback contracts only declare the fields the UI sends today. The storefront
// implementations also read optional overrides, so their param types extend the contract.
export type FormatAddressParams = Parameters<FormattedAddressAndProductAvailability>[0] & {
  variant?: string
  countryCode?: string
  startDate?: string
  endDate?: string
  tributeDate?: string
}
export type DeliveryOptionsParams = Parameters<DeliveryOptions>[0] & { variantKey?: string }
export type IsFulfillableParams = Parameters<IsProductFulfillable>[0] & {
  productKey?: string
  variantKey?: string
  occasion?: string
  isCourierUpgrade?: boolean
  isClickAndCollect?: boolean
}
export const PRODUCTS_ORDERED_FROM_STORAGE_KEY = 'products_order_from'
export const BIRTHDAY_CAMPAIGN_STORAGE_KEY = 'birthday_campaign_coupon_data'
